import { MarketingSectionCopy } from '@/components/marketing/marketing-section-copy'

export function SectionHeader({
  eyebrow,
  title,
  lead,
  align = 'left',
  className,
}: {
  eyebrow?: string
  title: string
  lead?: string
  align?: 'left' | 'center'
  className?: string
}) {
  return (
    <MarketingSectionCopy
      kicker={eyebrow}
      title={title}
      lead={lead}
      align={align}
      className={className}
    />
  )
}
